<!--
 Created by Xuz on 2019/03/05.
 xuz[at]live[dot]cn
 编辑文档类别
-->
<template>
    <a-modal title="编辑文档类别"
             :width="800"
             :visible="visible"
             :maskClosable="false"
             @ok="onSubmit"
             @cancel="onCancel"
             :confirmLoading="modalLoading">
        <a-form :form="form">
            <a-form-item
                    label='所属目录'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-select :options="cateRootList" v-decorator="[
                            'parentId',
                            {initialValue:modalData.parentId}]"/>
            </a-form-item>
            <a-form-item
                    label='类别名称'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-input v-decorator="[
                            'name',
                            {initialValue:modalData.name, rules: [{ required: true, message: '请填写类别名称' }]}]" placeholder='类别名称'/>
            </a-form-item>
            <a-form-item
                    label='流水号'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-select allowClear :options="fileNoList" v-decorator="[
                            'fileNoId',
                            {initialValue:modalData.fileNoId}
                            ]"/>
            </a-form-item>
            <a-form-item
                label='催办流程'
                :labelCol="{ span: 5 }"
                :wrapperCol="{ span: 12 }">
              <a-select allowClear :options="urgencyProcList" v-decorator="[
                              'urgencyProcId',
                              {initialValue:modalData.urgencyProcId}]"/>
            </a-form-item>
            <a-form-item
                    label='管理角色'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-select allowClear :options="roleList" v-decorator="[
                            'manageRoleId',
                            {initialValue:modalData.manageRoleId}]"/>
            </a-form-item>
            <a-form-item
                    label='查看页面'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-input v-decorator="[
                            'url',
                            {initialValue:modalData.url, rules: [{ required: true, message: '请填写查看页面路径' }]}]" placeholder='查看页面路径'/>
            </a-form-item>
            <a-form-item
                    label='描述'
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 12 }">
                <a-input v-decorator="[
                            'description',
                            {initialValue:modalData.description, rules: [{ required: false, message: '请填写描述' }]}]" placeholder='描述'/>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
  name: 'DocCateEdit',
  props: {
  },
  data () {
    return {
      visible: false,
      form: this.$form.createForm(this),
      modalLoading: false,
      fileNoList: [],
      cateRootList: [],
      roleList: [],
      urgencyProcList: [],
      modalData: {
        extras: {
          parentName: ''
        }
      }
    }
  },
  methods: {
    preCateEdit (id) {
      this.visible = true
      this.modalLoading = true
      const that = this
      axios.all([
        that.$http.get('/api/1/workflow/cate/get_fileno_list.json'),
        that.$http.get('/api/1/perm/role_flat_list.json'),
        that.$http.get('/api/1/workflow/cate/get_doc_root_list.json'),
        that.$http.get('/api/1/workflow/cate/get_doc.json?id=' + id),
        that.$http.get('/api/1/workflow/cate/get_urgency_process_list.json')
      ]).then(axios.spread((resp0, resp1, resp2, resp3, resp4) => {
        that.fileNoList = that.mapSelectData(resp0.result)
        that.roleList = that.mapSelectData(resp1.result)
        that.cateRootList = that.mapSelectData(resp2.result)
        that.urgencyProcList = that.mapSelectData(resp4.result)
        that.modalData = resp3.result
        that.modalLoading = false
      }))
    },
    onSubmit () {
      let that = this
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        let params = { ...this.modalData, ...this.form.getFieldsValue() }
        this.modalLoading = true
        this.$http.post('/api/1/workflow/cate/edit_doc.json', qs.stringify(params)).then(function () {
          that.visible = false
          that.$message.success('操作成功')
          that.form.resetFields()
          that.modalLoading = false
          that.$emit('success')
        })
      })
    },
    onCancel () {
      this.visible = false
      this.$emit('cancel')
    },
    mapSelectData (list) {
      return list.map(item => {
        return {
          value: item.id,
          label: item.name
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
